import LocationOnIcon from '@mui/icons-material/LocationOn';
import { formatAddress } from '@footsteps/shared';
import { FlowActionId, FlowStepId } from '../woz-flow.types';
import type { FlowContext, FlowStepDefinition } from '../woz-flow.types';
import type { WozCaseViewModelRef } from '../woz-flow.types';

export const findAddressStep: FlowStepDefinition = {
  id: FlowStepId.FindAddress,
  type: 'action',
  text: 'Welkom! Ik help je graag met het indienen van je WOZ-bezwaar. Laten we beginnen met het opzoeken van je adres.',
  actions: [
    {
      id: FlowActionId.FindAddress,
      label: 'Adres invoeren',
      primaryButton: true,
      disabledLabel: 'Adres bevestigd',
      icon: LocationOnIcon,
      event: 'openModal',
      payload: FlowStepId.FindAddress,
    },
  ],
  disableInput: true,
  waitForTrigger: FlowStepId.FindAddress,
  skipIf: (ctx: FlowContext) => !!ctx.addressData,
  meta: {
    action: 'find-address',
    onComplete: (viewModel: WozCaseViewModelRef, data: unknown) => {
      viewModel.completeTrigger(FlowStepId.FindAddress, { addressData: data });
    },
    formatBubble: (data: unknown) => {
      const fields = data as Record<string, unknown> | null;
      if (!fields) return null;
      return `**Ik wil bezwaar maken tegen de WOZ-waarde van mijn woning:**\n\n${formatAddress(fields, { multiLine: true })}`;
    },
  },
};
